import { useLocation } from "react-router-dom";
import ViewChargeModal from "./view-charges/viewChargesModal";
import ViewContractModal from "./view-contract/ViewContractModal";

type ModalProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
  module: string;
  item?: {};
  setDashboardUpdate?: React.Dispatch<React.SetStateAction<boolean>>;
};

const Modal: React.FC<ModalProps> = ({
  showModal,
  module,
  item,
  setShowModal,
  handleClose,
  setDashboardUpdate,
}) => {
  const url = useLocation();
  const moduleName = url.pathname.includes("charges")
    ? "charges"
    : url.pathname.includes("contracts")
    ? "contract"
    : "";

  return (
    <div>
      {moduleName === "charges" ? (
        <ViewChargeModal
          showModal={showModal}
          setShowModal={setShowModal}
          handleClose={handleClose}
          item={item}
          setDashboardUpdate={setDashboardUpdate}
        />
      ) : moduleName === "contract" ? (
        <ViewContractModal
          showModal={showModal}
          setShowModal={setShowModal}
          handleClose={handleClose}
          item={item}
        ></ViewContractModal>
      ) : (
        ""
      )}
    </div>
  );
};

export default Modal;
